/**
 * Global dictionary management page.
 * Allows tenants to define words that should always be redacted or always allowed
 * across all cases (global scope).
 */

import { useNavigate } from 'react-router-dom';
import { ArrowLeft, BookOpen } from 'lucide-react';
import { IconTooltip } from '../components/ui/tooltip';
import { DictionaryManager } from '../components/management/DictionaryManager';

export function DictionaryPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border bg-white">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-4">
          <IconTooltip label="Back to cases">
            <button
              onClick={() => navigate('/')}
              className="p-2 hover:bg-muted rounded-lg transition-colors"
              aria-label="Back"
            >
              <ArrowLeft className="w-5 h-5 text-foreground" />
            </button>
          </IconTooltip>
          <div className="flex items-center gap-2">
            <BookOpen className="w-5 h-5 text-[#7035C4]" />
            <h1 className="text-lg font-semibold">Global Word Dictionary</h1>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-8">
        <DictionaryManager />
      </main>
    </div>
  );
}
